<div class="universes-container">
  <app-back-button-component />

  @if (isLoadingUniverses()) {
    <app-loading-component
      [title]="'Rolling The Dice'"
      [message]="'Loading universes from the backend.'"
    />
  } @else if (isCreatingUniverse) {
    <app-loading-component
      [title]="'Forging A New World'"
      [message]="'Saving the new universe to the backend.'"
    />
  } @else if (isUpdatingUniverse) {
    <app-loading-component
      [title]="'Rewriting The Chronicles'"
      [message]="'Updating universe details on the backend.'"
    />
  } @else if (deletingUniverseId) {
    <app-loading-component
      [title]="'Burying A Realm'"
      [message]="'Applying the universe deletion on the backend.'"
    />
  } @else if (loadUniversesError()) {
    <section class="status-card">
      <h2>Could Not Load Universes</h2>
      <p>{{ loadUniversesError() }}</p>
    </section>
  } @else {
    <!-- Existing universe cards -->
    @if (getVisibleUniverses().length > 0) {
      @for (universe of getVisibleUniverses(); track universe.id) {
        <details class="universe-card">
          <summary class="universe-summary">
            <strong>{{ universe.name }}</strong>
          </summary>

          <div class="universe-content">
            <div class="button-row">
              @if (isEditingUniverse(universe)) {
                <button
                  type="button"
                  class="secondary-btn"
                  (click)="cancelEditingUniverse()"
                  [disabled]="isUpdatingUniverse"
                >
                  Cancel Edit
                </button>
                <button
                  type="button"
                  class="primary-btn"
                  (click)="updateUniverse(universe)"
                  [disabled]="!canUpdateUniverse() || isUpdatingUniverse"
                >
                  {{ isUpdatingUniverse ? 'Saving...' : 'Save Changes' }}
                </button>
              } @else {
                <button
                  type="button"
                  class="secondary-btn"
                  (click)="startEditingUniverse(universe)"
                  [disabled]="!!editingUniverseId || deletingUniverseId === universe.id"
                >
                  Edit Universe
                </button>
              }
              <button
                type="button"
                class="danger-btn"
                (click)="deleteUniverse(universe)"
                [disabled]="deletingUniverseId === universe.id || isEditingUniverse(universe)"
              >
                {{ deletingUniverseId === universe.id ? 'Deleting...' : 'Delete Universe' }}
              </button>
            </div>

            @if (isEditingUniverse(universe)) {
              <div class="form-group">
                <label [for]="'edit-universe-name-' + universe.id">Name</label>
                <input
                  [id]="'edit-universe-name-' + universe.id"
                  type="text"
                  [(ngModel)]="editingUniverseDraft.name"
                  placeholder="Enter universe name"
                />
              </div>

              <div class="form-group">
                <label [for]="'edit-universe-description-' + universe.id">Description</label>
                <textarea
                  [id]="'edit-universe-description-' + universe.id"
                  rows="4"
                  [(ngModel)]="editingUniverseDraft.description"
                  placeholder="Enter universe description"
                ></textarea>
              </div>
            } @else {
              <p><strong>Description:</strong> {{ universe.description }}</p>
            }

            <!-- Universe entities -->
            <details class="section-block">
              <summary><strong>Entities</strong></summary>

              <details class="sub-block">
                <summary><strong>Characters</strong></summary>

                <details class="sub-block">
                  <summary><strong>Playable Characters</strong></summary>

                  @if (getPlayableEntities(isEditingUniverse(universe) ? getEditingUniverse() : universe).length > 0) {
                    @for (entity of getPlayableEntities(isEditingUniverse(universe) ? getEditingUniverse() : universe); track entity.id || $index) {
                      <details class="item-card">
                        <summary>
                          <strong>{{ entity.name }}</strong>
                        </summary>

                        <div class="sub-block">
                          @if (isEditingUniverse(universe)) {
                            <div class="form-group">
                              <label [for]="'playable-entity-name-' + universe.id + '-' + $index">Name</label>
                              <input
                                [id]="'playable-entity-name-' + universe.id + '-' + $index"
                                type="text"
                                [(ngModel)]="entity.name"
                                placeholder="Enter entity name"
                              />
                            </div>
                            <div class="form-group">
                              <label [for]="'playable-entity-type-' + universe.id + '-' + $index">Type</label>
                              <input
                                [id]="'playable-entity-type-' + universe.id + '-' + $index"
                                type="text"
                                [(ngModel)]="entity.type"
                                placeholder="Enter entity type"
                              />
                            </div>
                            <div class="form-group">
                              <label [for]="'playable-entity-description-' + universe.id + '-' + $index">Description</label>
                              <textarea
                                [id]="'playable-entity-description-' + universe.id + '-' + $index"
                                rows="3"
                                [(ngModel)]="entity.description"
                                placeholder="Enter entity description"
                              ></textarea>
                            </div>
                            <div class="button-row">
                              <button type="button" class="secondary-btn" (click)="addStat(entity)">Add Stat</button>
                              <button type="button" class="danger-btn" (click)="removeUniverseEntity(entity)">Remove Entity</button>
                            </div>
                          } @else {
                            <p><strong>Type:</strong> {{ entity.type }}</p>
                            <p><strong>Description:</strong> {{ entity.description }}</p>
                          }

                          <details class="sub-block">
                            <summary><strong>Stats</strong></summary>

                            @if (getStats(entity).length > 0) {
                              @for (stat of getStats(entity); track stat.name || $index) {
                                @if (isEditingUniverse(universe)) {
                                  <div class="stat-edit-row">
                                    <input
                                      type="text"
                                      [(ngModel)]="stat.name"
                                      placeholder="Stat name"
                                    />
                                    <input
                                      type="number"
                                      [(ngModel)]="stat.value"
                                      placeholder="0"
                                    />
                                    <button type="button" class="danger-btn" (click)="removeStat(entity, $index)">Remove</button>
                                  </div>
                                } @else {
                                  <p>
                                    <strong>{{ stat.name }}:</strong> {{ stat.value }}
                                  </p>
                                }
                              }
                            } @else {
                              <p>No stats found.</p>
                            }
                          </details>
                        </div>
                      </details>
                    }
                  } @else {
                    <p>No playable characters.</p>
                  }

                  @if (isEditingUniverse(universe)) {
                    <div class="button-row">
                      <button type="button" class="secondary-btn" (click)="addUniverseEntity(true)">Add Playable Character</button>
                    </div>
                  }
                </details>

                <details class="sub-block">
                  <summary><strong>Non-Playable Characters</strong></summary>

                  @if (getNonPlayableEntities(isEditingUniverse(universe) ? getEditingUniverse() : universe).length > 0) {
                    @for (entity of getNonPlayableEntities(isEditingUniverse(universe) ? getEditingUniverse() : universe); track entity.id || $index) {
                      <details class="item-card">
                        <summary>
                          <strong>{{ entity.name }}</strong>
                        </summary>

                        <div class="sub-block">
                          @if (isEditingUniverse(universe)) {
                            <div class="form-group">
                              <label [for]="'npc-name-' + universe.id + '-' + $index">Name</label>
                              <input
                                [id]="'npc-name-' + universe.id + '-' + $index"
                                type="text"
                                [(ngModel)]="entity.name"
                                placeholder="Enter entity name"
                              />
                            </div>
                            <div class="form-group">
                              <label [for]="'npc-type-' + universe.id + '-' + $index">Type</label>
                              <input
                                [id]="'npc-type-' + universe.id + '-' + $index"
                                type="text"
                                [(ngModel)]="entity.type"
                                placeholder="Enter entity type"
                              />
                            </div>
                            <div class="form-group">
                              <label [for]="'npc-description-' + universe.id + '-' + $index">Description</label>
                              <textarea
                                [id]="'npc-description-' + universe.id + '-' + $index"
                                rows="3"
                                [(ngModel)]="entity.description"
                                placeholder="Enter entity description"
                              ></textarea>
                            </div>
                            <div class="button-row">
                              <button type="button" class="secondary-btn" (click)="addStat(entity)">Add Stat</button>
                              <button type="button" class="danger-btn" (click)="removeUniverseEntity(entity)">Remove Entity</button>
                            </div>
                          } @else {
                            <p><strong>Type:</strong> {{ entity.type }}</p>
                            <p><strong>Description:</strong> {{ entity.description }}</p>
                          }

                          <details class="sub-block">
                            <summary><strong>Stats</strong></summary>

                            @if (getStats(entity).length > 0) {
                              @for (stat of getStats(entity); track stat.name || $index) {
                                @if (isEditingUniverse(universe)) {
                                  <div class="stat-edit-row">
                                    <input type="text" [(ngModel)]="stat.name" placeholder="Stat name" />
                                    <input type="number" [(ngModel)]="stat.value" placeholder="0" />
                                    <button type="button" class="danger-btn" (click)="removeStat(entity, $index)">Remove</button>
                                  </div>
                                } @else {
                                  <p>
                                    <strong>{{ stat.name }}:</strong> {{ stat.value }}
                                  </p>
                                }
                              }
                            } @else {
                              <p>No stats found.</p>
                            }
                          </details>
                        </div>
                      </details>
                    }
                  } @else {
                    <p>No non-playable characters.</p>
                  }

                  @if (isEditingUniverse(universe)) {
                    <div class="button-row">
                      <button type="button" class="secondary-btn" (click)="addUniverseEntity(false)">Add Non-Playable Character</button>
                    </div>
                  }
                </details>
              </details>
            </details>

            <!-- Universe maps -->
            <details class="section-block">
              <summary><strong>Maps</strong></summary>

              @if (getMaps(isEditingUniverse(universe) ? getEditingUniverse() : universe).length > 0) {
                @for (map of getMaps(isEditingUniverse(universe) ? getEditingUniverse() : universe); track map.id || $index) {
                  <details class="item-card">
                    <summary>
                      <strong>{{ map.name }}</strong>
                    </summary>

                    <div class="sub-block">
                      @if (isEditingUniverse(universe)) {
                        <div class="form-group">
                          <label [for]="'map-name-' + universe.id + '-' + $index">Name</label>
                          <input [id]="'map-name-' + universe.id + '-' + $index" type="text" [(ngModel)]="map.name" placeholder="Enter map name" />
                        </div>
                        <div class="form-group">
                          <label [for]="'map-description-' + universe.id + '-' + $index">Description</label>
                          <textarea [id]="'map-description-' + universe.id + '-' + $index" rows="3" [(ngModel)]="map.description" placeholder="Enter map description"></textarea>
                        </div>
                        <div class="form-group">
                          <label [for]="'map-size-' + universe.id + '-' + $index">Size</label>
                          <input [id]="'map-size-' + universe.id + '-' + $index" type="text" [(ngModel)]="map.size" placeholder="Enter map size" />
                        </div>
                        <div class="form-group">
                          <label [for]="'map-location-' + universe.id + '-' + $index">Location</label>
                          <input [id]="'map-location-' + universe.id + '-' + $index" type="text" [(ngModel)]="map.location" placeholder="Enter map location" />
                        </div>
                        <div class="button-row">
                          <button type="button" class="danger-btn" (click)="removeUniverseMap(map)">Remove Map</button>
                        </div>
                      } @else {
                        <p><strong>Description:</strong> {{ map.description }}</p>
                        <p><strong>Size:</strong> {{ map.size }}</p>
                        <p><strong>Location:</strong> {{ map.location }}</p>
                      }
                    </div>
                  </details>
                }
              } @else {
                <p>No maps found.</p>
              }

              @if (isEditingUniverse(universe)) {
                <div class="button-row">
                  <button type="button" class="secondary-btn" (click)="addUniverseMap()">Add Map</button>
                </div>
              }
            </details>

            <!-- Universe campaigns -->
            <details class="section-block">
              <summary><strong>Campaigns</strong></summary>

              @if (getCampaigns(isEditingUniverse(universe) ? editingUniverseDraft : universe).length > 0) {
                @for (campaign of getCampaigns(isEditingUniverse(universe) ? editingUniverseDraft : universe); track campaign.id || $index) {
                  <details class="item-card">
                    <summary>
                      <strong>{{ campaign.name }}</strong>
                    </summary>

                    <div class="sub-block">
                      @if (isEditingUniverse(universe)) {
                        <div class="form-group">
                          <label [for]="'edit-campaign-name-' + universe.id + '-' + $index">Campaign Name</label>
                          <input
                            [id]="'edit-campaign-name-' + universe.id + '-' + $index"
                            type="text"
                            [(ngModel)]="campaign.name"
                            placeholder="Enter campaign name"
                          />
                        </div>

                        <div class="form-group">
                          <label [for]="'edit-campaign-description-' + universe.id + '-' + $index">Campaign Description</label>
                          <textarea
                            [id]="'edit-campaign-description-' + universe.id + '-' + $index"
                            rows="3"
                            [(ngModel)]="campaign.description"
                            placeholder="Enter campaign description"
                          ></textarea>
                        </div>

                        <div class="button-row">
                          <button
                            type="button"
                            class="danger-btn"
                            (click)="removeEditCampaign($index)"
                            [disabled]="getCampaigns(editingUniverseDraft).length === 1"
                          >
                            Remove Campaign
                          </button>
                        </div>
                      } @else {
                        <p><strong>Description:</strong> {{ campaign.description }}</p>
                      }

                      <details class="sub-block">
                        <summary><strong>Entities</strong></summary>

                        @if (getCampaignEntities(campaign).length > 0) {
                          @for (entity of getCampaignEntities(campaign); track entity.id || $index) {
                            <details class="item-card">
                              <summary>
                                <strong>{{ entity.name }}</strong>
                              </summary>

                              <div class="sub-block">
                                @if (isEditingUniverse(universe)) {
                                  <div class="form-group">
                                    <label>Name</label>
                                    <input type="text" [(ngModel)]="entity.name" placeholder="Enter entity name" />
                                  </div>
                                  <div class="form-group">
                                    <label>Type</label>
                                    <input type="text" [(ngModel)]="entity.type" placeholder="Enter entity type" />
                                  </div>
                                  <div class="form-group">
                                    <label>Description</label>
                                    <textarea rows="3" [(ngModel)]="entity.description" placeholder="Enter entity description"></textarea>
                                  </div>
                                  <div class="form-group">
                                    <label>
                                      <input type="checkbox" [(ngModel)]="entity.isPlayable" />
                                      Playable
                                    </label>
                                  </div>
                                  <div class="button-row">
                                    <button type="button" class="secondary-btn" (click)="addStat(entity)">Add Stat</button>
                                    <button type="button" class="danger-btn" (click)="removeCampaignEntity(campaign, entity)">Remove Entity</button>
                                  </div>
                                } @else {
                                  <p><strong>Type:</strong> {{ entity.type }}</p>
                                }

                                @if (getStats(entity).length > 0) {
                                  @for (stat of getStats(entity); track stat.name || $index) {
                                    @if (isEditingUniverse(universe)) {
                                      <div class="stat-edit-row">
                                        <input type="text" [(ngModel)]="stat.name" placeholder="Stat name" />
                                        <input type="number" [(ngModel)]="stat.value" placeholder="0" />
                                        <button type="button" class="danger-btn" (click)="removeStat(entity, $index)">Remove</button>
                                      </div>
                                    } @else {
                                      <p>
                                        <strong>{{ stat.name }}:</strong> {{ stat.value }}
                                      </p>
                                    }
                                  }
                                } @else if (!isEditingUniverse(universe)) {
                                  <p>No stats found.</p>
                                }
                              </div>
                            </details>
                          }
                        } @else {
                          <p>No entities.</p>
                        }

                        @if (isEditingUniverse(universe)) {
                          <div class="button-row">
                            <button type="button" class="secondary-btn" (click)="addCampaignEntity(campaign, true)">Add Playable Entity</button>
                            <button type="button" class="secondary-btn" (click)="addCampaignEntity(campaign, false)">Add Non-Playable Entity</button>
                          </div>
                        }
                      </details>

                      <details class="sub-block">
                        <summary><strong>Maps</strong></summary>

                        @if (getMaps(campaign).length > 0) {
                          @for (map of getMaps(campaign); track map.id || $index) {
                            <details class="item-card">
                              <summary>
                                <strong>{{ map.name }}</strong>
                              </summary>

                              <div class="sub-block">
                                @if (isEditingUniverse(universe)) {
                                  <div class="form-group">
                                    <label>Name</label>
                                    <input type="text" [(ngModel)]="map.name" placeholder="Enter map name" />
                                  </div>
                                  <div class="form-group">
                                    <label>Description</label>
                                    <textarea rows="3" [(ngModel)]="map.description" placeholder="Enter map description"></textarea>
                                  </div>
                                  <div class="form-group">
                                    <label>Size</label>
                                    <input type="text" [(ngModel)]="map.size" placeholder="Enter map size" />
                                  </div>
                                  <div class="form-group">
                                    <label>Location</label>
                                    <input type="text" [(ngModel)]="map.location" placeholder="Enter map location" />
                                  </div>
                                  <div class="button-row">
                                    <button type="button" class="danger-btn" (click)="removeCampaignMap(campaign, map)">Remove Map</button>
                                  </div>
                                } @else {
                                  <p>{{ map.description }}</p>
                                  <p>{{ map.size }} | {{ map.location }}</p>
                                }
                              </div>
                            </details>
                          }
                        } @else {
                          <p>No maps.</p>
                        }

                        @if (isEditingUniverse(universe)) {
                          <div class="button-row">
                            <button type="button" class="secondary-btn" (click)="addCampaignMap(campaign)">Add Map</button>
                          </div>
                        }
                      </details>
                    </div>
                  </details>
                }
              } @else {
                <p>No campaigns found.</p>
              }

              @if (isEditingUniverse(universe)) {
                <div class="button-row">
                  <button type="button" class="secondary-btn" (click)="addEditCampaign()">Add Campaign</button>
                </div>
              }
            </details>
          </div>
        </details>
      }
    } @else {
      <p>No universes found.</p>
    }

    @if (deleteUniverseError) {
      <section class="status-card">
        <h2>Could Not Delete Universe</h2>
        <p>{{ deleteUniverseError }}</p>
      </section>
    }

    @if (updateUniverseError) {
      <section class="status-card">
        <h2>Could Not Update Universe</h2>
        <p>{{ updateUniverseError }}</p>
      </section>
    }

    <!-- New universe creation card -->
    <details
      class="universe-card"
      [open]="isNewUniverseOpen"
      (toggle)="onNewUniverseToggle($event)"
    >
      <summary class="universe-summary">
        <strong>New Universe</strong>
      </summary>

      <div class="universe-content">
        <div class="form-group">
          <label for="universeName">Name</label>
          <input
            id="universeName"
            type="text"
            [(ngModel)]="newUniverse.name"
            placeholder="Enter universe name"
          />
        </div>

        <div class="form-group">
          <label for="universeDescription">Description</label>
          <textarea
            id="universeDescription"
            rows="4"
            [(ngModel)]="newUniverse.description"
            placeholder="Enter universe description"
          ></textarea>
        </div>

        <!-- New universe campaigns -->
        <details class="section-block" open>
          <summary><strong>Campaigns</strong></summary>

          @if (getCampaigns(newUniverse).length > 0) {
            @for (campaign of getCampaigns(newUniverse); track $index) {
              <details class="item-card" [open]="$first">
                <summary>
                  <strong>
                    {{ campaign.name || 'Campaign ' + ($index + 1) }}
                  </strong>
                </summary>

                <div class="sub-block">
                  <div class="form-group">
                    <label [for]="'campaign-name-' + $index">Campaign Name</label>
                    <input
                      [id]="'campaign-name-' + $index"
                      type="text"
                      [(ngModel)]="campaign.name"
                      placeholder="Enter campaign name"
                    />
                  </div>

                  <div class="form-group">
                    <label [for]="'campaign-description-' + $index">Campaign Description</label>
                    <textarea
                      [id]="'campaign-description-' + $index"
                      rows="3"
                      [(ngModel)]="campaign.description"
                      placeholder="Enter campaign description"
                    ></textarea>
                  </div>

                  <div class="button-row">
                    <button
                      type="button"
                      class="danger-btn"
                      (click)="removeCampaign($index)"
                      [disabled]="getCampaigns(newUniverse).length === 1"
                    >
                      Remove Campaign
                    </button>
                  </div>
                </div>
              </details>
            }
          }

          <div class="button-row">
            <button type="button" class="secondary-btn" (click)="addCampaign()">Add Campaign</button>
          </div>
        </details>

        <div class="button-row">
          <button
            type="button"
            class="primary-btn"
            (click)="createUniverse()"
            [disabled]="!canCreateUniverse() || isCreatingUniverse"
          >
            {{ isCreatingUniverse ? 'Saving...' : 'Save Universe' }}
          </button>
        </div>

        @if (createError) {
          <p class="validation-text">{{ createError }}</p>
        }

        @if (!canCreateUniverse()) {
          <p class="validation-text">
            Universe name, description, and at least one fully filled campaign are required.
          </p>
        }
      </div>
    </details>
  }
</div>
